import { useTranslation } from "react-i18next";
import SEOHead from "@/components/base/SEOHead";
import Breadcrumb from "@/components/base/Breadcrumb";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/data";

export default function ArticleListPage() {
  const { t } = useTranslation();

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "创作者学院 - 快猫视频",
    description: t("article.desc"),
    url: "https://www.kuaimaovideo.com/article",
  };

  return (
    <>
      <SEOHead
        title="创作者学院"
        description={t("article.desc")}
        keywords="短视频创作教程,短视频拍摄技巧,创作者变现,短视频运营,快猫视频教程"
        schema={articleSchema}
      />
      <Breadcrumb items={[{ label: t("article.title") }]} />

      <section className="py-8 md:py-12 bg-background-50">
        <div className="container-page">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              {t("article.title")}
            </h1>
            <p className="text-foreground-500">{t("article.desc")}</p>
          </div>

          <div className="flex flex-col gap-5">
            {articles.map((article) => (
              <ArticleCard key={article.id} {...article} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}